let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5suze")).then(() => parcelRequire('fRcce'));